import React, { Component } from 'react';
import {getPVReportViewerDetails} from '../../../data/report_viewer_api';
import {Button, Modal,TransitionablePortal, Header, Icon, Input, Image, Message, Popup, Segment, Divider} from "semantic-ui-react";
import Loader from '../../universal/loader';
import PVInfoContainer from "./pv_info_container"
import moment from "moment"

class PVReportViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pvId:this.props.match.params.pvId,
            token: this.props.match.params.token,
            loading: true,
            error: false,
            errormessage: undefined,
            pvDetails: undefined,
            images: [],
            currentImage: undefined,
          currentImageId: undefined,
          submitted:false,
            showModal: false,
            zoom: 100,
            
        }
    }

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    let data = {}
    
    for (let params of query.entries()) {
      data[params[0]] = params[1];
  }
        
        getPVReportViewerDetails(this.state.pvId, this.state.token).then((response) => {
          if (response.status === 200) {
                if (response.data.property_visit) {
                    this.setState({ loading: false, pvDetails: response.data.property_visit});
                }
            }
            else if (response.status === 412) { this.setState({ loading: false, error: true, errormessage:response.message }) };
        })
    }
    addToImagesList = (image) =>{
        if (image.image_path) {
            let newImages = this.state.images
            newImages.push(image)
            this.setState({ images: newImages })
        }else{}
    }
    getIndexOfObjectIfExists = (arrObj, searchId) => {
        for (let i = 0; i < arrObj.length; i++) {
          if (arrObj[i]['id'] === searchId) {
            return i;
          }
        }
        return -1;
    };
    setCurrentImage = (image) => {
        var imageID = this.getIndexOfObjectIfExists(this.state.images,image["id"])
        this.setState({ currentImage: image, showModal: true, currentImageId: imageID })
    }
    nextImage = () => {
        var newImageID = this.state.currentImageId + 1 
        this.setState({ currentImage: this.state.images[newImageID],currentImageId: newImageID})
      }
      prevImage = () => {
        this.setState({ currentImage: this.state.images[this.state.currentImageId -1],currentImageId: this.state.currentImageId -1})
      }
    toggleZoom = () => {
        this.state.zoom == 100 ?this.setState({ zoom: 200 }) : this.setState({zoom:100})
    }
    render() {

        return(
          <div>
            {this.state.loading ? <Loader contain={true} customText={"Loading Online Report Viewer"} /> : <React.Fragment>  
            <TransitionablePortal transition={{ animation: "scale", duration: 250 }} open={this.state.showModal} >
          <Modal
            onClose={() => this.setState({ showModal: false })}
                        open
                        size="fullscreen"
            style={{ height: "95%",overflow:"scroll"}}
          >
                        <Modal.Content image style={{ height: "100%" }}>
                            <div className="modal-close-button">          
                <Button
                  icon
                  onClick={(e) => {
                    this.toggleZoom();
                  }}
                >
                  
                                    <Icon name="search"/>
                                    {this.state.zoom}%
                </Button>
                {this.state.currentImageId > 0 ? <Button
                                    icon
                  onClick={(e) => {
                    this.prevImage();
                  }}
                >
                  
                  <Icon name="left arrow" />
                </Button> : null}
                {this.state.currentImageId +1 < this.state.images.length ? <Button
                  icon
                  onClick={(e) => {
                    this.nextImage();
                  }}>
                  <Icon name="right arrow" />
                </Button> : null}
                                <Button
                                    negative
                  icon
                  onClick={(e) => {
                    this.setState({ showModal: false });
                  }}
                >
                  <Icon name="close" />
                </Button>
              </div>
            <Image rounded centered style={{ height: this.state.zoom + "%", width: "auto",maxWidth:this.state.zoom+"%" }} src={this.state.currentImage? this.state.currentImage.image_path_hq?this.state.currentImage.image_path_hq:this.state.currentImage.image_path:null} />
            </Modal.Content>
          </Modal>
        </TransitionablePortal>
                {this.state.error ? <React.Fragment>
                    <Message size='mini' negative onDismiss={() => {this.setState({error: false})}}>
                <Message.Header>{"Error acessing Online Report"}</Message.Header>
                <p>{this.state.errormessage}</p>
                    </Message><h1 align="center">Something Went Wrong!</h1></React.Fragment> : null}
                {this.state.pvDetails ? <div>
                    <Divider horizontal>
                        <Header as='h4'>
                            <Icon name='home' />
                            {this.state.pvDetails.address} | Mid Term Inspection | {moment(this.state.pvDetails.visit_date, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY")}
                  </Header>
              </Divider>
                 <Segment className="viewer-content">
               <PVInfoContainer setCurrentImage={this.setCurrentImage} addToImagesList={this.addToImagesList}  pvDetails={this.state.pvDetails} />
              </Segment>
                </div> : null}</React.Fragment>} </div>)
    }
}

export default PVReportViewer


// WEBPACK FOOTER //
// ./src/views/property_visits/pv_report_viewer/index.js